
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5cc2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5cc2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iyjrR", function(module, exports) {
module.exports = import("8BShk").then(()=>parcelRequire('jaZ7o'));

});

parcelRegister("8ZFBQ", function(module, exports) {
module.exports = import("ilUZb").then(()=>parcelRequire('6fGU3'));

});

const $c9407a767cd80aee$export$1f12680e68c5100d = {
    en: {
        'Enter names below': 'Enter names below',
        Shuffle: 'Shuffle',
        Start: 'Start',
        Map: 'Map',
        Recording: 'Recording',
        'Winner count': 'Winner count',
        'The winner is': 'The winner is',
        'Using skills': 'Using skills',
        'Buy me a coffee': 'Buy me a coffee',
        First: 'First',
        Last: 'Last',
        'Wheel of fortune': 'Wheel of fortune',
        BubblePop: 'BubblePop',
        'Pot of greed': 'Pot of greed',
        'Yoru ni Kakeru': 'Into The Night (by item4)',
        'Chzzk Cheese Road': 'Chzzk Cheese Road',
        'Shake!': 'Shake!',
        'Input names separated by commas or line feed here': 'Input names separated by commas or line feed here',
        'This program is freeware and may be used freely anywhere, including in broadcasts and videos.': 'This program is freeware and may be used freely anywhere, including in broadcasts and videos.',
        'Close': 'Close',
        'The result has been copied': 'The result has been copied'
    },
    ko: {
        'Title': "\uC774\uBCA4\uD2B8 \uC81C\uBAA9",
        'Enter names below': "\uD6C4\uBCF4 \uBAA9\uB85D",
        Shuffle: "\uC11E\uAE30",
        Start: "\uC2DC\uC791",
        Map: "\uB9F5",
        Recording: "\uB179\uD654",
        'Winner count': "\uC6B0\uC2B9\uC790 \uC218",
        'The winner is': "\uB2F9\uCCA8 \uC21C\uC704",
        'Using skills': "\uC2A4\uD0AC \uD65C\uC131\uD654",
        'Buy me a coffee': "\uAC1C\uBC1C\uC790\uC5D0\uAC8C \uCEE4\uD53C \uC0AC\uC8FC\uAE30",
        First: "\uCCAB\uBC88\uC9F8",
        Last: "\uB9C8\uC9C0\uB9C9",
        'Wheel of fortune': "\uC6B4\uBA85\uC758 \uC218\uB808\uBC14\uD034",
        BubblePop: "\uBC84\uBE14\uD31D",
        'Pot of greed': "\uC695\uB9DD\uC758 \uD56D\uC544\uB9AC",
        'Yoru ni Kakeru': "\uBC24\uC744 \uB2EC\uB9AC\uB2E4 (by item4)",
        'Chzzk Cheese Road': "\uCE58\uC9C0\uC9C1 \uCE58\uC988 \uD30C\uD2F0 (Long)",
        'Chzzk Cheese Rolling': "\uCE58\uC9C0\uC9C1 \uCE58\uC988 \uAD74\uB9AC\uAE30 (Mid)",
        'Chzzk Spinning Log': "\uCE58\uC9C0\uC9C1 \uD68C\uC804\uD558\uB294 \uD1B5\uB098\uBB34 (Short)",
        'Shake!': "\uD754\uB4E4\uAE30!",
        'Input names separated by commas or line feed here': "\uC774\uB984\uC744 \uC27C\uD45C\uB098 \uC5D4\uD130\uB85C \uAD6C\uBD84\uD574\uC11C \uB123\uC5B4\uC8FC\uC138\uC694",
        'This program is freeware and may be used freely anywhere, including in broadcasts and videos.': "\uC774 \uD504\uB85C\uADF8\uB7A8\uC740 \uD504\uB9AC\uC6E8\uC5B4\uC774\uBA70 \uBC29\uC1A1\uC774\uB098 \uC601\uC0C1 \uB4F1\uC744 \uD3EC\uD568\uD55C \uC5B4\uB5A4 \uC6A9\uB3C4\uB85C\uB4E0 \uC790\uC720\uB86D\uAC8C \uC0AC\uC6A9\uD558\uB294 \uAC83\uC774 \uD5C8\uC6A9\uB418\uC5B4\uC788\uC2B5\uB2C8\uB2E4.",
        'Close': "\uB2EB\uAE30",
        'The result has been copied': "\uACB0\uACFC\uAC00 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4"
    }
};


const $f38b96567aa47566$var$defaultLocale = 'en';
let $f38b96567aa47566$var$locale;
function $f38b96567aa47566$var$getBrowserLocale() {
    return navigator.language.split('-')[0];
}
function $f38b96567aa47566$var$translateElement(element) {
    if (!(element instanceof HTMLElement) || !$f38b96567aa47566$var$locale) return;
    const prop = element.getAttribute('data-trans');
    if (prop) {
        const key = (element.getAttribute(prop) || '').trim();
        if (key && key in (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale]) element.setAttribute(prop, (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale][key]);
    } else {
        const key = element.innerText.trim();
        if (key && key in (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale]) element.innerText = (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale][key];
    }
}
function $f38b96567aa47566$var$translatePage() {
    document.querySelectorAll('[data-trans]').forEach($f38b96567aa47566$var$translateElement);
}
function $f38b96567aa47566$var$setLocale(newLocale) {
    if (newLocale === $f38b96567aa47566$var$locale) return;
    document.documentElement.lang = newLocale;
    const newLocaleLower = newLocale.toLocaleLowerCase();
    $f38b96567aa47566$var$locale = newLocaleLower in (0, $c9407a767cd80aee$export$1f12680e68c5100d) ? newLocaleLower : $f38b96567aa47566$var$defaultLocale;
    $f38b96567aa47566$var$translatePage();
}
document.addEventListener('DOMContentLoaded', ()=>{
    console.log('localization loaded');
    const browserLocale = $f38b96567aa47566$var$getBrowserLocale();
    console.log('detected locale: ', browserLocale);
    $f38b96567aa47566$var$setLocale(browserLocale);
});
// eslint-disable-next-line
window.translateElement = $f38b96567aa47566$var$translateElement;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


const $1d1927fc5b91d8b6$export$c2cc40734f29867c = 30;
const $1d1927fc5b91d8b6$export$1cd840e6ecaab774 = 1600;
const $1d1927fc5b91d8b6$export$3d795bc15e02aca = 900;
const $1d1927fc5b91d8b6$export$677ef9a3ce6796cf = 5;
const $1d1927fc5b91d8b6$export$2708cc8cc9b2d975 = 5000;
var $1d1927fc5b91d8b6$export$bc572fe44976cfbc = /*#__PURE__*/ function(Skills) {
    Skills[Skills["None"] = 0] = "None";
    Skills[Skills["Impact"] = 1] = "Impact";
    return Skills;
}({});
const $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd = {
    box: 'cyan',
    circle: 'yellow',
    polyline: '#00FFA3'
};
const $1d1927fc5b91d8b6$export$452bc121f02cf9e8 = {
    box: 'cyan',
    circle: 'yellow',
    polyline: '#00FFA3'
};


function $28770b279d7ab5b1$export$29e4e862bebba87f(degree) {
    return Math.PI * degree / 180;
}
function $28770b279d7ab5b1$var$getRegexValue(regex, str) {
    const result = regex.exec(str);
    return result ? result[1] : '';
}
function $28770b279d7ab5b1$export$5d945868514965a9(nameStr) {
    const weightRegex = /\/(\d+)/;
    const countRegex = /\*(\d+)/;
    const hasWeight = weightRegex.test(nameStr);
    const hasCount = countRegex.test(nameStr);
    const name = $28770b279d7ab5b1$var$getRegexValue(/^\s*([^\/*]+)?/, nameStr).trim();
    if (!name) return null;
    const weight = hasWeight ? parseInt($28770b279d7ab5b1$var$getRegexValue(weightRegex, nameStr)) : 1;
    const count = hasCount ? parseInt($28770b279d7ab5b1$var$getRegexValue(countRegex, nameStr)) : 1;
    return {
        name: name,
        weight: weight,
        count: count
    };
}
function $28770b279d7ab5b1$export$5d04458e2a6c373e(v) {
    return v.toString().padStart(2, '0');
}


class $2573268c577c952d$var$Options {
    constructor(){
        this.useSkills = true;
        this.winningRank = 0;
        this.winnerCount = 1 // 우승자 수 (1~20)
        ;
    }
}
const $2573268c577c952d$var$options = new $2573268c577c952d$var$Options();
var $2573268c577c952d$export$2e2bcd8739ae039 = $2573268c577c952d$var$options;


class $5aa23f633f590d4c$export$9b781de7bf37bf48 {
    static sub(v1, v2) {
        return {
            x: v2.x - v1.x,
            y: v2.y - v1.y
        };
    }
    static lenSq(v) {
        return v.x * v.x + v.y * v.y;
    }
    static len(v) {
        return Math.sqrt(this.lenSq(v));
    }
    static mul(v, scalar) {
        return {
            x: v.x * scalar,
            y: v.y * scalar
        };
    }
    static add(v1, v2) {
        return {
            x: v1.x + v2.x,
            y: v1.y + v2.y
        };
    }
}


class $e7b6517817360fee$export$e91dba6fa3f67f68 {
    get position() {
        return this.physics.getMarblePosition(this.id) || {
            x: 0,
            y: 0,
            angle: 0
        };
    }
    get x() {
        return this.position.x;
    }
    set x(v) {
        this.position.x = v;
    }
    get y() {
        return this.position.y;
    }
    set y(v) {
        this.position.y = v;
    }
    get angle() {
        return this.position.angle;
    }
    constructor(physics, order, max, name, weight = 1){
        this.type = 'marble';
        this.name = '';
        this.size = 0.5;
        this.color = 'red';
        this.hue = 0;
        this.impact = 0;
        this.weight = 1;
        this.skill = (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
        this.isActive = false;
        this._skillRate = 0.01;
        this._coolTime = 5000;
        this._maxCoolTime = 5000;
        this._stuckTime = 0;
        this.lastPosition = {
            x: 0,
            y: 0
        };
        this.name = name || `M${order}`;
        this.weight = weight;
        this.physics = physics;
        this._maxCoolTime = 1000 + (1 - this.weight) * 4000;
        this._coolTime = this._maxCoolTime * Math.random();
        this._skillRate = 0.2 * this.weight;
        const maxLine = Math.ceil(max / 10);
        const line = Math.floor(order / 10);
        const lineDelta = -Math.max(0, Math.ceil(maxLine - 5));
        this.hue = 360 / max * order;
        this.color = `hsl(${this.hue} 100% 70%)`;
        this.id = order;
        physics.createMarble(order, 10.25 + order % 10 * 0.6, maxLine - line + lineDelta);
    }
    update(deltaTime) {
        if (this.isActive && (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).lenSq((0, $5aa23f633f590d4c$export$9b781de7bf37bf48).sub(this.lastPosition, this.position)) < 0.00001) {
            this._stuckTime += deltaTime;
            if (this._stuckTime > (0, $1d1927fc5b91d8b6$export$2708cc8cc9b2d975)) {
                this.physics.shakeMarble(this.id);
                this._stuckTime = 0;
            }
        } else this._stuckTime = 0;
        this.lastPosition = {
            x: this.position.x,
            y: this.position.y
        };
        this.skill = (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
        if (this.impact) this.impact = Math.max(0, this.impact - deltaTime);
        if (!this.isActive) return;
        if ((0, $2573268c577c952d$export$2e2bcd8739ae039).useSkills) this._updateSkillInformation(deltaTime);
    }
    _updateSkillInformation(deltaTime) {
        if (this._coolTime > 0) this._coolTime -= deltaTime;
        if (this._coolTime <= 0) {
            this.skill = Math.random() < this._skillRate ? (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).Impact : (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
            this._coolTime = this._maxCoolTime;
        }
    }
    render(ctx, zoom, outline, isMinimap = false, skin, viewPort) {
        const viewPortHw = viewPort.w / viewPort.zoom / 2;
        const viewPortHh = viewPort.h / viewPort.zoom / 2;
        const viewPortLeft = viewPort.x - viewPortHw;
        const viewPortRight = viewPort.x + viewPortHw;
        const viewPortTop = viewPort.y - viewPortHh - this.size / 2;
        const viewPortBottom = viewPort.y + viewPortHh;
        if (!isMinimap && (this.x < viewPortLeft || this.x > viewPortRight || this.y < viewPortTop || this.y > viewPortBottom)) return;
        const transform = ctx.getTransform();
        if (isMinimap) this._renderMinimap(ctx);
        else this._renderNormal(ctx, zoom, outline, skin);
        ctx.setTransform(transform);
    }
    _renderMinimap(ctx) {
        ctx.fillStyle = this.color;
        this._drawMarbleBody(ctx, true);
    }
    _drawMarbleBody(ctx, isMinimap) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, isMinimap ? this.size : this.size / 2, 0, Math.PI * 2);
        ctx.fill();
    }
    _renderNormal(ctx, zoom, outline, skin) {
        const hs = this.size / 2;
        if (this._stuckTime > 0) ctx.fillStyle = `hsl(${this.hue} 100% ${70 + 25 * Math.min(1, this._stuckTime / (0, $1d1927fc5b91d8b6$export$2708cc8cc9b2d975))}%`;
        else ctx.fillStyle = `hsl(${this.hue} 100% ${70 + 25 * Math.min(1, this.impact / 500)}%`;
        // ctx.shadowColor = this.color;
        // ctx.shadowBlur = zoom / 2;
        if (skin) {
            ctx.translate(this.x, this.y);
            ctx.rotate(this.angle);
            ctx.drawImage(skin, -hs, -hs, hs * 2, hs * 2);
            ctx.rotate(-this.angle);
            ctx.translate(-this.x, -this.y);
        } else this._drawMarbleBody(ctx, false);
        ctx.shadowColor = '';
        ctx.shadowBlur = 0;
        this._drawName(ctx, zoom);
        if (outline) this._drawOutline(ctx, 2 / zoom);
        if ((0, $2573268c577c952d$export$2e2bcd8739ae039).useSkills) this._renderCooltime(ctx, zoom);
    // this._renderStuck(ctx, zoom); // for debug
    }
    _drawName(ctx, zoom) {
        ctx.font = `${12 / zoom}pt NanumSquareNeo, sans-serif`;
        ctx.strokeStyle = 'black';
        ctx.lineWidth = 2 / zoom;
        ctx.fillStyle = this.color;
        ctx.shadowBlur = 0;
        ctx.strokeText(this.name, this.x, this.y + 0.25);
        ctx.fillText(this.name, this.x, this.y + 0.25);
    }
    _drawOutline(ctx, lineWidth) {
        ctx.beginPath();
        ctx.strokeStyle = 'white';
        ctx.lineWidth = lineWidth;
        ctx.arc(this.x, this.y, this.size / 2, 0, Math.PI * 2);
        ctx.stroke();
    }
    _renderCooltime(ctx, zoom) {
        ctx.strokeStyle = 'red';
        ctx.lineWidth = 1 / zoom;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size / 2 + 2 / zoom, (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(270), (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(270 + 360 * this._coolTime / this._maxCoolTime));
        ctx.stroke();
    }
}





const $2139b4f99d5088b5$var$lifetime = 3000;
class $2139b4f99d5088b5$export$c36c68baa13912a5 {
    constructor(x, y){
        this._elapsed = 0;
        this.position = {
            x: 0,
            y: 0
        };
        this.force = {
            x: 0,
            y: 0
        };
        this.color = '';
        this.isDestroy = false;
        this.position.x = x;
        this.position.y = y;
        const force = Math.random() * 250;
        const ang = (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(90 * Math.random() - 180);
        const fx = Math.cos(ang) * force;
        const fy = Math.sin(ang) * force;
        this.color = `hsl(${Math.random() * 360} 50% 50%)`;
        this.force = {
            x: fx,
            y: fy
        };
    }
    update(deltaTime) {
        this._elapsed += deltaTime;
        const delta = (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).mul(this.force, deltaTime / 100);
        this.position = (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).add(this.position, delta);
        this.force.y += 10 * deltaTime / 100;
        if (this._elapsed > $2139b4f99d5088b5$var$lifetime) this.isDestroy = true;
    }
    render(ctx) {
        ctx.save();
        ctx.globalAlpha = 1 - Math.pow(this._elapsed / $2139b4f99d5088b5$var$lifetime, 2);
        ctx.fillStyle = this.color;
        ctx.fillRect(this.position.x, this.position.y, 20, 20);
        ctx.restore();
    }
}


class $69fffa06e2cc8da9$export$6658904c50100579 {
    update(deltaTime) {
        this._particles.forEach((particle)=>{
            particle.update(deltaTime);
        });
        this._particles = this._particles.filter((particle)=>!particle.isDestroy);
    }
    render(ctx) {
        this._particles.forEach((particle)=>particle.render(ctx));
    }
    shot(x, y) {
        for(let i = 0; i < 200; i++)this._particles.push(new (0, $2139b4f99d5088b5$export$c36c68baa13912a5)(x, y));
    }
    constructor(){
        this._particles = [];
    }
}


const $b2abafc93d11a512$export$1bfcff8d7c4bf05 = [
    {
        title: 'Chzzk Cheese Road',
        goalY: 245,
        zoomY: 230,
        entities: [
            // 왼쪽 벽
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            8,
                            -300
                        ],
                        [
                            8,
                            30
                        ],
                        [
                            3,
                            35
                        ],
                        [
                            3,
                            60
                        ],
                        [
                            7,
                            64
                        ],
                        [
                            7,
                            90
                        ],
                        [
                            3,
                            94
                        ],
                        [
                            3,
                            120
                        ],
                        [
                            7,
                            124
                        ],
                        [
                            7,
                            150
                        ],
                        [
                            3,
                            154
                        ],
                        [
                            3,
                            180
                        ],
                        [
                            7,
                            184
                        ],
                        [
                            7,
                            210
                        ],
                        [
                            4,
                            213
                        ],
                        [
                            4,
                            235
                        ],
                        [
                            13.5,
                            241
                        ],
                        [
                            13.5,
                            247
                        ]
                    ]
                }
            },
            // 오른쪽 벽
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            18,
                            -300
                        ],
                        [
                            18,
                            30
                        ],
                        [
                            23,
                            35
                        ],
                        [
                            23,
                            60
                        ],
                        [
                            19,
                            64
                        ],
                        [
                            19,
                            90
                        ],
                        [
                            23,
                            94
                        ],
                        [
                            6,
                            110
                        ],
                        [
                            23,
                            120
                        ],
                        [
                            19,
                            124
                        ],
                        [
                            19,
                            150
                        ],
                        [
                            23,
                            154
                        ],
                        [
                            23,
                            180
                        ],
                        [
                            19,
                            184
                        ],
                        [
                            19,
                            210
                        ],
                        [
                            22,
                            213
                        ],
                        [
                            22,
                            235
                        ],
                        [
                            14.5,
                            241
                        ],
                        [
                            14.5,
                            247
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            10,
                            165
                        ],
                        [
                            17,
                            168
                        ],
                        [
                            17,
                            172
                        ],
                        [
                            10,
                            175
                        ]
                    ]
                }
            },
            // 좁은 골인 지점 - 회전 바 (Wheel of fortune 스타일)
            {
                position: {
                    x: 12.3,
                    y: 241.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: -1.2,
                    restitution: 0
                }
            },
            // 회전 바퀴들 (치즈 구멍 느낌)
            {
                position: {
                    x: 10,
                    y: 20
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 20
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: -3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6,
                    y: 60
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20,
                    y: 60
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10,
                    y: 100
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: 5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 100
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: -5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6,
                    y: 140
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20,
                    y: 140
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 185
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 7.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 220
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -8,
                    restitution: 0
                }
            },
            // 초입 static 바
            {
                position: {
                    x: 14,
                    y: 40
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 7.5,
                    height: 0.1,
                    rotation: -110.1,
                    color: '#00FFA3'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12,
                    y: 45
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 9,
                    height: 0.1,
                    rotation: 110.06,
                    color: '#00FFA3'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.5,
                    y: 48
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.1,
                    rotation: -110.06,
                    color: '#00FFA3'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            // 치즈 구멍 (튕기는 원형 장애물)
            {
                position: {
                    x: 13,
                    y: 30
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.5,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 50
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 50
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17,
                    y: 50
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 70
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.8,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 90
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.0,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 90
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.0,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 130
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.0,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17,
                    y: 130
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.0,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 150
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 170
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.8,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18,
                    y: 170
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.8,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 190
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.0,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 210
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.6,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 210
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.6,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            // 작은 다이아몬드 장애물 (Wheel of fortune 스타일)
            {
                position: {
                    x: 10,
                    y: 35
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 35
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 35
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 65
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 65
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 65
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 65
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 135
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 135
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 135
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 135
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 175
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 175
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 175
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 205
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 207
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 201
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 199
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 193
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.3,
                    height: 0.3,
                    rotation: 45,
                    color: '#FFEB3B'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            // 지그재그 핀들 (Yoru ni Kakeru 스타일)
            {
                position: {
                    x: 10,
                    y: 55
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 55
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 55
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 55
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 57
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 57
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 57
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 4,
                    y: 115
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 6,
                    y: 115
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 115
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 115
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 5,
                    y: 117
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 7,
                    y: 117
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 117
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 6,
                    y: 235.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 236.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 237.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 242
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 242.2
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 242.4
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 155
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 155
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 155
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 155
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 157
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 157
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 157
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 18,
                    y: 195
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 18,
                    y: 197
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 203
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 200
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 200
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 200
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 200
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 200
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 18,
                    y: 200
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            // 경사진 바 (Yoru ni Kakeru 스타일)
            {
                position: {
                    x: 10,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.1,
                    rotation: 30,
                    color: '#FFFFFF'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.1,
                    rotation: -30,
                    color: '#FFFFFF'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10,
                    y: 145
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.1,
                    rotation: -20,
                    color: '#FFFFFF'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 145
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.1,
                    rotation: 20,
                    color: '#FFFFFF'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.4,
                    restitution: 0
                }
            },
            // 추가 작은 원형 장애물들
            {
                position: {
                    x: 11,
                    y: 78
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.4,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 78
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.4,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 78
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.4,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 148
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.4,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 148
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.4,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 148
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.4,
                    life: 1
                }
            },
            // 큰 박스 장애물 (BubblePop 스타일)
            {
                position: {
                    x: 9,
                    y: 25
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 2.5,
                    rotation: 60,
                    color: '#FFEAA7'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 25
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 2.5,
                    rotation: 50,
                    color: '#FFEAA7'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 125
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 3,
                    rotation: 45,
                    color: '#FFEAA7'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            // 최종 구간 회전 바
            {
                position: {
                    x: 7,
                    y: 225
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 225
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14,
                    y: 232
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFD700'
                },
                props: {
                    density: 1,
                    angularVelocity: -6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 215
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 215
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 225
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 215
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7,
                    y: 220
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19,
                    y: 220
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            // 튕기는 영구적 원
            {
                position: {
                    x: 4,
                    y: 235.2
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#FFEB3B'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5
                }
            },
            {
                position: {
                    x: 8,
                    y: 237.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#FFEB3B'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 2
                }
            },
            {
                position: {
                    x: 11,
                    y: 239.6
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.35,
                    color: '#FFEB3B'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5
                }
            }
        ]
    },
    {
        title: 'Chzzk Cheese Rolling',
        goalY: 120,
        zoomY: 110,
        entities: [
            // 왼쪽 벽
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            8,
                            -300
                        ],
                        [
                            8,
                            25
                        ],
                        [
                            3,
                            30
                        ],
                        [
                            3,
                            40
                        ],
                        [
                            17,
                            50
                        ],
                        [
                            3,
                            60
                        ],
                        [
                            5,
                            70
                        ],
                        [
                            12,
                            84
                        ],
                        [
                            3,
                            100
                        ],
                        [
                            10,
                            110
                        ],
                        [
                            13,
                            120
                        ],
                        [
                            13,
                            122
                        ]
                    ]
                }
            },
            // 오른쪽 벽
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            18,
                            -300
                        ],
                        [
                            18,
                            25
                        ],
                        [
                            6,
                            35
                        ],
                        [
                            23,
                            45
                        ],
                        [
                            21,
                            50
                        ],
                        [
                            7,
                            64
                        ],
                        [
                            18,
                            80
                        ],
                        [
                            20,
                            86
                        ],
                        [
                            18,
                            94
                        ],
                        [
                            8,
                            100
                        ],
                        [
                            18,
                            110
                        ],
                        [
                            15,
                            120
                        ],
                        [
                            15,
                            122
                        ]
                    ]
                }
            },
            // 결승 지점 회전 바 (y=117 부근)
            {
                position: {
                    x: 14,
                    y: 114
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#FFA500'
                },
                props: {
                    density: 1,
                    angularVelocity: -6,
                    restitution: 0
                }
            },
            // 경사진 선에 걸친 튕기는 원형들
            // 경사 구간)
            {
                position: {
                    x: 9,
                    y: 11
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 12
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 13
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 14
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17,
                    y: 15
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 17
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 18
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 19
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 20
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17,
                    y: 21
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 23
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 24
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 25
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 26
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 41
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 42
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 43
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 44
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17,
                    y: 45
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 58.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 57
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 55.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 54
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17,
                    y: 52.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5,
                    y: 100
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7,
                    y: 103
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 106
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 109
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 112
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 116
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 116
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 116
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            // 선에 걸친 원형들
            {
                position: {
                    x: 14,
                    y: 28.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 29.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 30.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 30.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 31.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 33.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 28.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 29.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 29.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 30.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 31.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 32.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 33.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 49.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 48.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 48
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 47
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 46.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 46
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 45
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 44.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 43.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 7,
                    y: 42.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 6,
                    y: 42.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 5,
                    y: 41.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 4,
                    y: 40.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 49.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 48.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 47.8
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 46.8
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 46.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 45.8
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 44.8
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 44.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 43.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 7,
                    y: 42.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 6,
                    y: 41.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 5,
                    y: 41.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 4,
                    y: 40.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 95.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 95.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 96.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 97.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 97.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 98.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 98.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 99.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 100.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 7,
                    y: 100.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 6,
                    y: 101.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 5,
                    y: 101.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 95.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 15,
                    y: 95.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 96.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 96.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 12,
                    y: 97.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 11,
                    y: 98.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 98.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 9,
                    y: 99.3
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 8,
                    y: 99.9
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 7,
                    y: 100.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 6,
                    y: 101.1
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 5,
                    y: 101.7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            // 큰 원
            {
                position: {
                    x: 13,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.5,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.0,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.5,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 120
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.5,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 120
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.8,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 120
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 120
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.2,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 120
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.5,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            }
        ]
    },
    {
        title: 'Chzzk Spinning Log',
        goalY: 60,
        zoomY: 55,
        entities: [
            // 왼쪽 벽
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    color: '#FFFFFF',
                    bloomColor: '#00FFA3',
                    points: [
                        [
                            8,
                            -300
                        ],
                        [
                            8,
                            10
                        ],
                        [
                            6,
                            15
                        ],
                        [
                            6,
                            30
                        ],
                        [
                            8,
                            35
                        ],
                        [
                            8,
                            50
                        ],
                        [
                            8,
                            52
                        ],
                        [
                            13.5,
                            58
                        ],
                        [
                            13.5,
                            62
                        ]
                    ]
                }
            },
            // 오른쪽 벽
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    color: '#FFFFFF',
                    bloomColor: '#00FFA3',
                    points: [
                        [
                            18,
                            -300
                        ],
                        [
                            18,
                            10
                        ],
                        [
                            20,
                            15
                        ],
                        [
                            20,
                            30
                        ],
                        [
                            18,
                            35
                        ],
                        [
                            18,
                            50
                        ],
                        [
                            16,
                            55
                        ],
                        [
                            14.5,
                            58
                        ],
                        [
                            14.5,
                            62
                        ]
                    ]
                }
            },
            // 많은 회전 바들 (통나무 느낌 - 밝은 갈색 #D2691E)
            // 초반 구간 (y=5~15)
            {
                position: {
                    x: 10,
                    y: 5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 8
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10,
                    y: 11
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 11
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 14
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            // 중반 구간 (y=17~30)
            {
                position: {
                    x: 10,
                    y: 17
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 17
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 20
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 6,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 23
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 23
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 26
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 29
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 29
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            // 중후반 구간 (y=32~45)
            {
                position: {
                    x: 13,
                    y: 32
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9,
                    y: 35
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -1,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 35
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 1,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 38
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10,
                    y: 41
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 41
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 44
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.7,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            // 후반 구간 (y=47~60)
            {
                position: {
                    x: 9,
                    y: 47
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 47
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 50
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.7,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: -1.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 53
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 53
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: 2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 55
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.15,
                    rotation: 0,
                    color: '#CD853F'
                },
                props: {
                    density: 1,
                    angularVelocity: 4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 58
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.8,
                    height: 0.15,
                    rotation: 0,
                    color: '#D2691E'
                },
                props: {
                    density: 1,
                    angularVelocity: -1.2,
                    restitution: 0
                }
            },
            // 장식용 고정 원형들 (chzzk 색상 사용)
            {
                position: {
                    x: 13,
                    y: 7
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.2,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 16
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.2,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 25
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.2,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 34
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#00FFA3'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.2,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 43
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#FFFFFF'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.2,
                    life: 1
                }
            },
            {
                position: {
                    x: 13,
                    y: 52
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#704CE5'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.2,
                    life: 1
                }
            },
            // 작은 장식 원형들
            {
                position: {
                    x: 10,
                    y: 10
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 10
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 22
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 22
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 34
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 34
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 10,
                    y: 46
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 16,
                    y: 46
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.3,
                    color: '#FFA500'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 58
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 58
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            },
            {
                position: {
                    x: 14,
                    y: 58
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.4,
                    color: '#FFD700'
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.3,
                    life: 1
                }
            }
        ]
    }
];




class $238457a12dbae9c5$export$79f141de891a5fed {
    get zoom() {
        return this._zoom;
    }
    set zoom(v) {
        this._targetZoom = v;
    }
    get x() {
        return this._position.x;
    }
    set x(v) {
        this._targetPosition.x = v;
    }
    get y() {
        return this._position.y;
    }
    set y(v) {
        this._targetPosition.y = v;
    }
    get position() {
        return this._position;
    }
    setPosition(v, force = false) {
        if (force) return this._position = {
            x: v.x,
            y: v.y
        };
        return this._targetPosition = {
            x: v.x,
            y: v.y
        };
    }
    lock(v) {
        this._locked = v;
    }
    startFollowingMarbles() {
        this._shouldFollowMarbles = true;
        this._alternateViewTimer = 0;
        this._showingFrontMarble = false;
    }
    initializePosition() {
        const centerX = 12.95;
        const initialY = 2;
        this._position = {
            x: centerX,
            y: initialY
        };
        this._targetPosition = {
            x: centerX,
            y: initialY
        };
        this._shouldFollowMarbles = false;
    }
    update({ marbles: marbles, stage: stage, needToZoom: needToZoom, targetIndex: targetIndex, winnerRank: winnerRank, winnersCount: winnersCount, totalMarbleCount: totalMarbleCount }) {
        // set target position
        if (!this._locked) this._calcTargetPositionAndZoom(marbles, stage, needToZoom, targetIndex, winnerRank, winnersCount, totalMarbleCount);
        // interpolate position
        this._position.x = this._interpolation(this.x, this._targetPosition.x);
        this._position.y = this._interpolation(this.y, this._targetPosition.y);
        // interpolate zoom
        this._zoom = this._interpolation(this._zoom, this._targetZoom);
    }
    _calcTargetPositionAndZoom(marbles, stage, needToZoom, targetIndex, winnerRank, winnersCount, totalMarbleCount) {
        if (!this._shouldFollowMarbles) return;
        if (marbles.length === 0) {
            this.zoom = 1;
            return;
        }
        // 마지막 당첨 순위인지 확인
        const isLastWinner = winnerRank >= totalMarbleCount - 1;
        const hasWinners = winnersCount > 0;
        // 마지막 당첨 모드이고, 첫 번째 구슬이 이미 통과했으며, 구슬이 3개 이상 남았을 때
        if (isLastWinner && hasWinners && marbles.length >= 3) {
            const frontMarble = marbles[0]; // 제일 앞 구슬 (결승지점 기준)
            // 구슬이 10개 이하면: 카메라 전환 없이 제일 앞 구슬 고정 + 줌인 2배 + 슬로우모션
            if (marbles.length <= 10) {
                this.setPosition({
                    x: frontMarble.x,
                    y: frontMarble.y - 2
                });
                this.zoom = 2;
                return;
            }
            // 구슬이 11개 이상일 때: 기존 카메라 전환 로직
            const backMarble = marbles[marbles.length - 1]; // 제일 뒤 구슬
            const heightDifference = Math.abs(frontMarble.y - backMarble.y);
            // 높이 차이가 10 이상일 때만 카메라 전환
            if (heightDifference > 10) {
                this._alternateViewTimer += 10; // 10ms씩 증가
                if (this._alternateViewTimer >= this._viewSwitchInterval) {
                    this._alternateViewTimer = 0;
                    this._showingFrontMarble = !this._showingFrontMarble;
                }
                if (this._showingFrontMarble) // 제일 앞 구슬을 보여줄 때: 높이를 -2 위치로
                this.setPosition({
                    x: frontMarble.x,
                    y: frontMarble.y - 2
                });
                else // 제일 뒤 구슬을 보여줄 때
                this.setPosition(backMarble.position);
                // 줌은 기본 1배
                this.zoom = 1;
                return;
            }
        }
        // 일반 모드 또는 높이 차이가 크지 않을 때
        const targetMarble = marbles[targetIndex] ? marbles[targetIndex] : marbles[0];
        this.setPosition(targetMarble.position);
        // 첫번째 당첨 모드이고 결승지점 근처일 때 줌인 2배
        if (!isLastWinner && needToZoom) {
            const goalDist = Math.abs(stage.zoomY - this._position.y);
            if (goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 4.5) this.zoom = 2;
            else this.zoom = Math.max(2, (1 - goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) * 3);
        // 마지막 당첨 모드이고 구슬이 10개 이하 남고 결승 근처일 때 줌인 3배
        } else if (isLastWinner && marbles.length <= 10 && needToZoom) {
            const goalDist = Math.abs(stage.zoomY - this._position.y);
            if (goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 4.5) this.zoom = 3;
            else this.zoom = Math.max(3, (1 - goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) * 3);
        } else if (needToZoom) {
            const goalDist = Math.abs(stage.zoomY - this._position.y);
            this.zoom = Math.max(2, (1 - goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) * 3);
        } else this.zoom = 1;
    }
    _interpolation(current, target) {
        const d = target - current;
        if (Math.abs(d) < 1 / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)) return target;
        return current + d / 10;
    }
    renderScene(ctx, callback) {
        const zoomFactor = (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c) * 2 * this._zoom;
        ctx.save();
        ctx.translate(-this.x * this._zoom, -this.y * this._zoom);
        ctx.scale(this.zoom, this.zoom);
        ctx.translate(ctx.canvas.width / zoomFactor, ctx.canvas.height / zoomFactor);
        callback(ctx);
        ctx.restore();
    }
    constructor(){
        this._position = {
            x: 0,
            y: 0
        };
        this._targetPosition = {
            x: 0,
            y: 0
        };
        this._zoom = 1;
        this._targetZoom = 1;
        this._locked = false;
        this._shouldFollowMarbles = false;
        this._alternateViewTimer = 0;
        this._showingFrontMarble = false;
        this._viewSwitchInterval = 5000 // 5초마다 전환
        ;
    }
}



var $7d4e2a4155870a97$exports = {};
$7d4e2a4155870a97$exports = import.meta.resolve("6zsJJ");


var $00ab5f21765795c8$exports = {};
$00ab5f21765795c8$exports = import.meta.resolve("5jP9O");


var $15b751ac699c79f4$exports = {};
$15b751ac699c79f4$exports = import.meta.resolve("2966S");


var $c124a982a299e1f1$exports = {};
$c124a982a299e1f1$exports = import.meta.resolve("4ZEBz");


var $cd8ae239cdbf59a5$exports = {};
$cd8ae239cdbf59a5$exports = import.meta.resolve("ldpNv");


var $72b86cbfe1130bc2$exports = {};
$72b86cbfe1130bc2$exports = import.meta.resolve("g8LrH");


var $e0cf47afb0dd994b$exports = {};
$e0cf47afb0dd994b$exports = import.meta.resolve("fWvAn");


var $af3e633888312f75$exports = {};
$af3e633888312f75$exports = import.meta.resolve("6EyNz");


var $621df66674c3cae2$exports = {};
$621df66674c3cae2$exports = import.meta.resolve("91AT3");


var $97e01a2df2fc10f9$exports = {};
$97e01a2df2fc10f9$exports = import.meta.resolve("tHz3M");


var $f9e2f3aed4dfa6ff$exports = {};
$f9e2f3aed4dfa6ff$exports = import.meta.resolve("cW02k");


var $64766b70756aaf88$exports = {};
$64766b70756aaf88$exports = import.meta.resolve("duAL7");


var $9677e89c738862c5$exports = {};
$9677e89c738862c5$exports = import.meta.resolve("dSwII");


var $6183258c97ab2497$exports = {};
$6183258c97ab2497$exports = import.meta.resolve("dKQBf");


var $0ab5175620db5e6d$exports = {};
$0ab5175620db5e6d$exports = import.meta.resolve("2djJH");


var $98f09b88a16cb66a$exports = {};
$98f09b88a16cb66a$exports = import.meta.resolve("dviAY");


var $760afc903e1d16d1$exports = {};
$760afc903e1d16d1$exports = import.meta.resolve("5eH3J");


var $b14305d6540c6ff3$exports = {};
$b14305d6540c6ff3$exports = import.meta.resolve("9aWqs");


var $3a1639d20c3f0a23$exports = {};
$3a1639d20c3f0a23$exports = import.meta.resolve("ka2SP");


var $35b5bbcb00f60a5f$exports = {};
$35b5bbcb00f60a5f$exports = import.meta.resolve("lANBH");


var $65dcdb3109207d45$exports = {};
$65dcdb3109207d45$exports = import.meta.resolve("7FHhg");


var $955fe6dff1d20efa$exports = {};
$955fe6dff1d20efa$exports = import.meta.resolve("3dSLB");


var $fde943b0087de629$exports = {};
$fde943b0087de629$exports = import.meta.resolve("juMvj");


var $32eab135cccee554$exports = {};
$32eab135cccee554$exports = import.meta.resolve("KI0Fb");
























class $68facf3481e408fc$export$a1ed140729fa937 {
    constructor(){
        this.sizeFactor = 1;
        this._images = {};
        this._chzzkDefaultImages = [] // chzzk 1~22 기본 이미지 풀
        ;
        this._chzzkTrophyImage = null // 트로피 이미지
        ;
        this._title = "\uCE58\uC9C0\uC9C1 \uB8F0\uB81B" // 사용자 입력 타이틀
        ;
    }
    get width() {
        return this._canvas.width;
    }
    get height() {
        return this._canvas.height;
    }
    get canvas() {
        return this._canvas;
    }
    async init() {
        await this._load();
        this._canvas = document.createElement('canvas');
        this._canvas.width = (0, $1d1927fc5b91d8b6$export$1cd840e6ecaab774);
        this._canvas.height = (0, $1d1927fc5b91d8b6$export$3d795bc15e02aca);
        this.ctx = this._canvas.getContext('2d', {
            alpha: false
        });
        document.body.appendChild(this._canvas);
        const resizing = (entries)=>{
            const realSize = entries ? entries[0].contentRect : this._canvas.getBoundingClientRect();
            const width = Math.max(realSize.width / 2, 640);
            const height = width / realSize.width * realSize.height;
            this._canvas.width = width;
            this._canvas.height = height;
            this.sizeFactor = width / realSize.width;
        };
        const resizeObserver = new ResizeObserver(resizing);
        resizeObserver.observe(this._canvas);
        resizing();
    }
    async _loadImage(url) {
        return new Promise((rs)=>{
            const img = new Image();
            img.addEventListener('load', ()=>{
                rs(img);
            });
            img.src = url;
        });
    }
    async _load() {
        const loadPromises = [
            {
                name: "\uBCA0\uC774\uBE44\uBD80",
                imgUrl: new URL($7d4e2a4155870a97$exports)
            },
            {
                name: "\uC2A4\uB9C8\uC77C\uBD80",
                imgUrl: new URL($00ab5f21765795c8$exports)
            },
            {
                name: "\uB208\uBB3C\uBD80",
                imgUrl: new URL($15b751ac699c79f4$exports)
            },
            {
                name: "\uB180\uB780\uBD80",
                imgUrl: new URL($c124a982a299e1f1$exports)
            },
            {
                name: "\uACE8\uD504\uC610\uB85C\uBD80",
                imgUrl: new URL($cd8ae239cdbf59a5$exports)
            },
            {
                name: "\uACE8\uD504\uBD80",
                imgUrl: new URL($72b86cbfe1130bc2$exports)
            },
            {
                name: "\uD14C\uB2C8\uC2A4\uBD80",
                imgUrl: new URL($e0cf47afb0dd994b$exports)
            },
            {
                name: "\uD589\uBCF5\uBD80",
                imgUrl: new URL($af3e633888312f75$exports)
            },
            {
                name: "\uBAA8\uC790\uBD80",
                imgUrl: new URL($621df66674c3cae2$exports)
            },
            {
                name: "\uC120\uAE00\uB77C\uC2A4\uBD80",
                imgUrl: new URL($97e01a2df2fc10f9$exports)
            },
            {
                name: "\uD558\uD2B8\uCE58\uC988",
                imgUrl: new URL($f9e2f3aed4dfa6ff$exports)
            },
            {
                name: "\uD1B5\uB098\uBB34\uD30C\uC6CC",
                imgUrl: new URL($64766b70756aaf88$exports)
            },
            {
                name: "\uBC88\uAC1C\uC57C\uAD6C\uACF5",
                imgUrl: new URL($9677e89c738862c5$exports)
            },
            {
                name: "\uD48D\uC120\uC6B8\uB9AC",
                imgUrl: new URL($6183258c97ab2497$exports)
            },
            {
                name: "\uC218\uC601\uC6B8\uB9AC",
                imgUrl: new URL($0ab5175620db5e6d$exports)
            },
            {
                name: "\uBA4D\uC6B8\uB9AC",
                imgUrl: new URL($98f09b88a16cb66a$exports)
            },
            {
                name: "\uD799\uC6B8\uB9AC",
                imgUrl: new URL($760afc903e1d16d1$exports)
            },
            {
                name: "\uBA4D\uBD88\uB9AC",
                imgUrl: new URL($b14305d6540c6ff3$exports)
            },
            {
                name: "\uCC21\uAE0B\uD1A0\uBE44",
                imgUrl: new URL($3a1639d20c3f0a23$exports)
            },
            {
                name: "\uBCA0\uC774\uBE44\uD1A0\uBE44",
                imgUrl: new URL($35b5bbcb00f60a5f$exports)
            },
            {
                name: "\uC218\uC601\uD1A0\uBE44",
                imgUrl: new URL($65dcdb3109207d45$exports)
            },
            {
                name: "\uCE58\uC9C0\uC9C1",
                imgUrl: new URL($955fe6dff1d20efa$exports)
            }
        ].map(({ name: name, imgUrl: imgUrl })=>{
            return (async ()=>{
                this._images[name] = await this._loadImage(imgUrl.toString());
            })();
        });
        loadPromises.push((async ()=>{
            await this._loadImage(new URL($fde943b0087de629$exports).toString());
        })());
        // chzzk 트로피 이미지 로드
        loadPromises.push((async ()=>{
            try {
                this._chzzkTrophyImage = await this._loadImage(new URL($32eab135cccee554$exports).toString());
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        // chzzk 1~22 기본 이미지 로드 (명시되지 않은 이름들을 위해)
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($7d4e2a4155870a97$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($00ab5f21765795c8$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($15b751ac699c79f4$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($c124a982a299e1f1$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($cd8ae239cdbf59a5$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($72b86cbfe1130bc2$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($e0cf47afb0dd994b$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($af3e633888312f75$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($621df66674c3cae2$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($97e01a2df2fc10f9$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($f9e2f3aed4dfa6ff$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($64766b70756aaf88$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($9677e89c738862c5$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($6183258c97ab2497$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($0ab5175620db5e6d$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($98f09b88a16cb66a$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($760afc903e1d16d1$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($b14305d6540c6ff3$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($3a1639d20c3f0a23$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($35b5bbcb00f60a5f$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($65dcdb3109207d45$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        loadPromises.push((async ()=>{
            try {
                const img = await this._loadImage(new URL($955fe6dff1d20efa$exports).toString());
                this._chzzkDefaultImages.push(img);
            } catch  {
            // 이미지 로드 실패 시 무시
            }
        })());
        await Promise.all(loadPromises);
    }
    render(renderParameters, uiObjects) {
        this.ctx.fillStyle = 'black';
        this.ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
        this.ctx.save();
        this.ctx.scale((0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        this.ctx.textAlign = 'left';
        this.ctx.textBaseline = 'top';
        this.ctx.font = '0.4pt sans-serif';
        this.ctx.lineWidth = 3 / (renderParameters.camera.zoom + (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        renderParameters.camera.renderScene(this.ctx, ()=>{
            this.renderTrophy(renderParameters);
            this.renderEntities(renderParameters.entities);
            this.renderEffects(renderParameters);
            this.renderMarbles(renderParameters);
        });
        this.ctx.restore();
        // 타이틀은 HTML 요소로 표시 (index.html에서 처리)
        uiObjects.forEach((obj)=>obj.render(this.ctx, renderParameters, this._canvas.width, this._canvas.height));
        renderParameters.particleManager.render(this.ctx);
        this.renderWinner(renderParameters);
    }
    renderEntities(entities) {
        this.ctx.save();
        entities.forEach((entity)=>{
            const transform = this.ctx.getTransform();
            this.ctx.translate(entity.x, entity.y);
            this.ctx.rotate(entity.angle);
            this.ctx.fillStyle = entity.shape.color ?? (0, $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd)[entity.shape.type];
            this.ctx.strokeStyle = entity.shape.color ?? (0, $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd)[entity.shape.type];
            // 네온 효과 - polyline(벽)에만 강한 glow 적용
            if (entity.shape.type === 'polyline') {
                this.ctx.shadowBlur = 25;
                this.ctx.shadowColor = entity.shape.bloomColor ?? '#00FFA3';
                this.ctx.lineWidth = 0.15;
            } else {
                this.ctx.shadowBlur = 15;
                this.ctx.shadowColor = entity.shape.bloomColor ?? entity.shape.color ?? (0, $1d1927fc5b91d8b6$export$452bc121f02cf9e8)[entity.shape.type];
            }
            const shape = entity.shape;
            switch(shape.type){
                case 'polyline':
                    if (shape.points.length > 0) {
                        this.ctx.beginPath();
                        this.ctx.moveTo(shape.points[0][0], shape.points[0][1]);
                        for(let i = 1; i < shape.points.length; i++)this.ctx.lineTo(shape.points[i][0], shape.points[i][1]);
                        this.ctx.stroke();
                    }
                    break;
                case 'box':
                    const w = shape.width * 2;
                    const h = shape.height * 2;
                    this.ctx.rotate(shape.rotation);
                    this.ctx.fillRect(-w / 2, -h / 2, w, h);
                    this.ctx.strokeRect(-w / 2, -h / 2, w, h);
                    break;
                case 'circle':
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, shape.radius, 0, Math.PI * 2, false);
                    this.ctx.stroke();
                    break;
            }
            this.ctx.setTransform(transform);
        });
        this.ctx.restore();
    }
    renderEffects({ effects: effects, camera: camera }) {
        effects.forEach((effect)=>effect.render(this.ctx, camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)));
    }
    renderMarbles({ marbles: marbles, camera: camera, winnerRank: winnerRank, winners: winners, size: size }) {
        const winnerIndex = winnerRank - winners.length;
        const viewPort = {
            x: camera.x,
            y: camera.y,
            w: size.x,
            h: size.y,
            zoom: camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
        };
        marbles.forEach((marble, i)=>{
            // 명시적으로 정의된 이름은 해당 이미지 사용, 그 외는 chzzk 1~9 랜덤 사용
            const marbleImage = this._images[marble.name] || this._getChzzkImageForName(marble.name);
            marble.render(this.ctx, camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), i === winnerIndex, false, marbleImage, viewPort);
        });
    }
    // 이름을 해시하여 chzzk 1~22 중 하나를 일관되게 반환
    _getChzzkImageForName(name) {
        if (this._chzzkDefaultImages.length === 0) return undefined;
        // 이름을 해시하여 0~21 범위의 인덱스 생성
        let hash = 0;
        for(let i = 0; i < name.length; i++){
            hash = (hash << 5) - hash + name.charCodeAt(i);
            hash = hash & hash;
        }
        const index = Math.abs(hash) % this._chzzkDefaultImages.length;
        return this._chzzkDefaultImages[index];
    }
    renderWinner({ winner: winner, winnerCount: winnerCount }) {
        // 우승자 수가 1명일 때만 크게 표시
        if (!winner || winnerCount > 1) return;
        this.ctx.save();
        this.ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        this.ctx.fillRect(this._canvas.width / 2, this._canvas.height - 168, this._canvas.width / 2, 168);
        this.ctx.fillStyle = 'white';
        this.ctx.font = 'bold 48px sans-serif';
        this.ctx.textAlign = 'right';
        this.ctx.fillText('Winner', this._canvas.width - 10, this._canvas.height - 120);
        this.ctx.font = 'bold 72px sans-serif';
        this.ctx.fillStyle = winner.color;
        this.ctx.fillText(winner.name, this._canvas.width - 10, this._canvas.height - 55);
        this.ctx.restore();
    }
    // 타이틀 설정 (HTML 요소로 표시)
    setTitle(title) {
        this._title = title || "\uCE58\uC9C0\uC9C1 \uB8F0\uB81B";
        // HTML 요소 업데이트
        const titleElement = document.getElementById('game-title');
        if (titleElement) titleElement.textContent = this._title;
    }
    // 맵의 도착지점에 트로피 이미지 표시
    renderTrophy(renderParameters) {
        if (!this._chzzkTrophyImage) return;
        // Chzzk Cheese Road 맵의 goalY는 245
        const goalX = 14; // 골인 지점 중앙 x 좌표
        const goalY = renderParameters.stage.goalY + 7;
        this.ctx.save();
        const trophySize = 4; // 월드 좌표 기준 크기
        const trophyX = goalX - trophySize / 2;
        const trophyY = goalY - trophySize - 1; // 골인 지점 바로 위
        this.ctx.drawImage(this._chzzkTrophyImage, trophyX, trophyY, trophySize, trophySize);
        this.ctx.restore();
    }
}


const $43c01f2b0f9df660$var$lifetime = 500;
class $43c01f2b0f9df660$export$2faf2590ac4901e1 {
    constructor(x, y){
        this._size = 0;
        this._elapsed = 0;
        this.isDestroy = false;
        this.position = {
            x: x,
            y: y
        };
    }
    update(deltaTime) {
        this._elapsed += deltaTime;
        this._size = this._elapsed / $43c01f2b0f9df660$var$lifetime * 10;
        if (this._elapsed > $43c01f2b0f9df660$var$lifetime) this.isDestroy = true;
    }
    render(ctx, zoom) {
        ctx.save();
        const rate = this._elapsed / $43c01f2b0f9df660$var$lifetime;
        ctx.globalAlpha = 1 - rate * rate;
        ctx.strokeStyle = 'white';
        ctx.lineWidth = 1 / zoom;
        ctx.beginPath();
        ctx.arc(this.position.x, this.position.y, this._size, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
    }
}



function $5d9d2ddcc4e90c63$export$adf7c0fe6059d774(// eslint-disable-next-line
target, propertyKey, descriptor) {
    return {
        configurable: true,
        get () {
            const boundMethod = descriptor.value.bind(this);
            Object.defineProperty(this, propertyKey, {
                value: boundMethod,
                configurable: true,
                writable: true
            });
            return boundMethod;
        }
    };
}




class $e0350dec16bbe919$export$795f70ffe4ca76fc {
    constructor(){
        this._currentY = 0;
        this._targetY = 0;
        this.fontHeight = 16;
        this._userMoved = 0;
        this._currentWinner = -1;
        this.maxY = 0;
        this.winners = [];
        this.marbles = [];
        this.winnerRank = -1;
    }
    onWheel(e) {
        this._targetY += e.deltaY;
        if (this._targetY > this.maxY) this._targetY = this.maxY;
        this._userMoved = 2000;
    }
    onDblClick(e) {
        if (e) {
            if (navigator.clipboard) {
                const tsv = [];
                let rank = 0;
                tsv.push(...[
                    ...this.winners,
                    ...this.marbles
                ].map((m)=>{
                    rank++;
                    return [
                        rank.toString(),
                        m.name,
                        rank - 1 === this.winnerRank ? "\u2606" : ''
                    ].join('\t');
                }));
                tsv.unshift([
                    'Rank',
                    'Name',
                    'Winner'
                ].join('\t'));
                navigator.clipboard.writeText(tsv.join('\n')).then(()=>{
                    if (this.messageHandler) this.messageHandler('The result has been copied');
                });
            }
        }
    }
    onMessage(func) {
        this.messageHandler = func;
    }
    render(ctx, { winners: winners, marbles: marbles, winnerRank: winnerRank }, width, height) {
        const startX = width - 5;
        const startY = Math.max(-this.fontHeight, this._currentY - height / 2);
        this.maxY = Math.max(0, (marbles.length + winners.length) * this.fontHeight + this.fontHeight);
        this._currentWinner = winners.length;
        this.winners = winners;
        this.marbles = marbles;
        this.winnerRank = winnerRank;
        ctx.save();
        ctx.textAlign = 'right';
        ctx.font = '14pt NanumSquareNeo, sans-serif';
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("\uACE8\uC778 \uC218 : " + `${winners.length} / ${winners.length + marbles.length}`, width - 5, this.fontHeight);
        ctx.beginPath();
        ctx.rect(0, this.fontHeight + 2, width, this.maxY);
        ctx.clip();
        ctx.translate(0, -startY);
        ctx.font = 'bold 11pt NanumSquareNeo, sans-serif';
        winners.forEach((marble, rank)=>{
            const y = rank * this.fontHeight;
            if (y >= startY && y <= startY + ctx.canvas.height) {
                ctx.fillStyle = marble.color;
                ctx.fillText(`${rank === winnerRank ? "\u2606" : '\u2714'} ${marble.name} #${rank + 1}`, startX, 20 + y);
            }
        });
        ctx.font = '10pt NanumSquareNeo, sans-serif';
        marbles.forEach((marble, rank)=>{
            const y = (rank + winners.length) * this.fontHeight;
            if (y >= startY && y <= startY + ctx.canvas.height) {
                ctx.fillStyle = marble.color;
                ctx.fillText(`${marble.name} #${rank + 1 + winners.length}`, startX, 20 + y);
            }
        });
        ctx.restore();
    }
    update(deltaTime) {
        if (this._currentWinner === -1) return;
        if (this._userMoved > 0) this._userMoved -= deltaTime;
        else this._targetY = this._currentWinner * this.fontHeight + this.fontHeight;
        if (this._currentY !== this._targetY) this._currentY += (this._targetY - this._currentY) * (deltaTime / 250);
        if (Math.abs(this._currentY - this._targetY) < 1) this._currentY = this._targetY;
    }
    getBoundingBox() {
        return null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $e0350dec16bbe919$export$795f70ffe4ca76fc.prototype, "onWheel", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $e0350dec16bbe919$export$795f70ffe4ca76fc.prototype, "onDblClick", null);





class $c2ea39beabe51779$export$a8b4308ba35ee473 {
    constructor(){
        this.lastParams = null;
        this._onViewportChangeHandler = null;
        this.mousePosition = null;
        this.boundingBox = {
            x: 10,
            y: 10,
            w: 26 * 1.7,
            h: 0
        };
    }
    getBoundingBox() {
        return this.boundingBox;
    }
    onViewportChange(callback) {
        this._onViewportChangeHandler = callback;
    }
    update() {
    // nothing to do
    }
    onMouseMove(e) {
        if (!e) {
            this.mousePosition = null;
            if (this._onViewportChangeHandler) this._onViewportChangeHandler();
            return;
        }
        if (!this.lastParams) return;
        this.mousePosition = {
            x: e.x,
            y: e.y
        };
        if (this._onViewportChangeHandler) this._onViewportChangeHandler({
            x: this.mousePosition.x / 1.7,
            y: this.mousePosition.y / 1.7
        });
    }
    render(ctx, params) {
        if (!ctx) return;
        const { stage: stage } = params;
        if (!stage) return;
        const minimapScale = 1.7;
        this.boundingBox.h = stage.goalY * minimapScale;
        this.lastParams = params;
        this.ctx = ctx;
        ctx.save();
        ctx.fillStyle = '#333';
        ctx.translate(10, 10);
        ctx.scale(minimapScale, minimapScale);
        ctx.fillRect(0, 0, 26, stage.goalY);
        this.ctx.lineWidth = 0.15;
        this.drawEntities(params.entities);
        this.drawMarbles(params);
        this.drawViewport(params);
        ctx.restore();
        ctx.save();
        ctx.strokeStyle = 'green';
        ctx.lineWidth = 1;
        ctx.strokeRect(this.boundingBox.x, this.boundingBox.y, this.boundingBox.w, this.boundingBox.h);
        ctx.restore();
    }
    drawViewport(params) {
        this.ctx.save();
        const { camera: camera, size: size } = params;
        const zoom = camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c);
        const w = size.x / zoom;
        const h = size.y / zoom;
        this.ctx.strokeStyle = 'white';
        this.ctx.lineWidth = 30 / zoom;
        this.ctx.strokeRect(camera.x - w / 2, camera.y - h / 2, w, h);
        this.ctx.restore();
    }
    drawEntities(entities) {
        this.ctx.save();
        entities.forEach((entity)=>{
            this.ctx.save();
            this.ctx.fillStyle = entity.shape.color ?? (0, $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd)[entity.shape.type];
            this.ctx.strokeStyle = entity.shape.color ?? (0, $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd)[entity.shape.type];
            // 네온 효과 추가
            if (entity.shape.type === 'polyline') {
                this.ctx.shadowBlur = 0.3;
                this.ctx.shadowColor = entity.shape.bloomColor ?? '#00FFA3';
            }
            this.ctx.translate(entity.x, entity.y);
            this.ctx.rotate(entity.angle);
            this.ctx.save();
            const shape = entity.shape;
            switch(shape.type){
                case 'box':
                    const w = shape.width * 2;
                    const h = shape.height * 2;
                    this.ctx.rotate(shape.rotation);
                    this.ctx.fillRect(-w / 2, -h / 2, w, h);
                    break;
                case 'circle':
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, shape.radius, 0, Math.PI * 2, false);
                    this.ctx.stroke();
                    break;
                case 'polyline':
                    if (shape.points.length > 0) {
                        this.ctx.beginPath();
                        this.ctx.moveTo(shape.points[0][0], shape.points[0][1]);
                        for(let i = 1; i < shape.points.length; i++)this.ctx.lineTo(shape.points[i][0], shape.points[i][1]);
                        this.ctx.stroke();
                    }
                    break;
            }
            this.ctx.restore();
            this.ctx.restore();
        });
        this.ctx.restore();
    }
    drawMarbles(params) {
        const { marbles: marbles } = params;
        const viewPort = {
            x: params.camera.x,
            y: params.camera.y,
            w: params.size.x,
            h: params.size.y,
            zoom: params.camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
        };
        marbles.forEach((marble)=>{
            marble.render(this.ctx, 1, false, true, undefined, viewPort);
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $c2ea39beabe51779$export$a8b4308ba35ee473.prototype, "onMouseMove", null);


class $4dadba5eb7b1114b$export$ce9eedc15a17214 {
    constructor(){
        this.isGameStarted = false;
        this.topCandidates = [];
    }
    setGameStarted(started) {
        this.isGameStarted = started;
    }
    render(ctx, { winners: winners, marbles: marbles, winnerRank: winnerRank, stage: stage, totalMarbleCount: totalMarbleCount, winnerCount: winnerCount }, width, height) {
        // 게임이 시작되지 않았으면 표시하지 않음
        if (!this.isGameStarted) return;
        // 구슬도 없고 골인한 구슬도 없으면 표시하지 않음
        if (marbles.length < 1 && winners.length < 1) return;
        // 마지막 당첨 모드인지 확인
        const isLastWinner = winnerRank >= totalMarbleCount - 1;
        // 표시할 후보 수 결정 (1~5명이면 5명, 6~20명이면 winnerCount만큼)
        const displayCount = winnerCount <= 5 ? 5 : winnerCount;
        // 현재 유력한 후보 계산
        this.calculateTopCandidates(marbles, winners, winnerRank, isLastWinner, displayCount);
        if (this.topCandidates.length === 0) return;
        ctx.save();
        // 박스 높이는 표시할 후보 수에 따라 동적 계산
        const boxWidth = 150;
        const padding = 12;
        const lineHeight = 26;
        const titleHeight = 30;
        const boxHeight = titleHeight + lineHeight * this.topCandidates.length + padding;
        const startX = width - boxWidth - 90;
        const startY = height - boxHeight - 30;
        // 반투명 배경 with glow 효과
        ctx.fillStyle = 'rgba(0, 0, 0, 0.75)';
        ctx.strokeStyle = '#00FFA3';
        ctx.lineWidth = 2;
        ctx.shadowBlur = 25;
        ctx.shadowColor = '#00FFA3';
        ctx.beginPath();
        ctx.roundRect(startX, startY, boxWidth, boxHeight, 10);
        ctx.fill();
        ctx.stroke();
        ctx.shadowBlur = 0;
        // 최종 우승자 확정 여부 (winnerCount가 2명 이상일 때만 적용)
        // - 마지막 당첨 모드: 남은 구슬이 winnerCount 이하
        // - 첫번째 당첨 모드: 골인한 구슬이 winnerCount 이상
        const isFinalWinnersForLast = isLastWinner && marbles.length <= winnerCount && marbles.length > 0;
        const isFinalWinnersForFirst = !isLastWinner && winners.length >= winnerCount;
        const isFinalWinners = winnerCount >= 2 && (isFinalWinnersForLast || isFinalWinnersForFirst);
        // 타이틀
        ctx.fillStyle = '#00FFA3';
        ctx.font = 'bold 10pt NanumSquareNeo, sans-serif';
        ctx.textAlign = 'left';
        const titleText = isFinalWinners ? `\u{1F389} \u{CD5C}\u{C885} \u{C6B0}\u{C2B9} ${winnerCount}\u{C778}` : "\uD83C\uDFC6 \uC720\uB825 \uC6B0\uC2B9 \uD6C4\uBCF4";
        ctx.fillText(titleText, startX + padding + 1, startY + padding + 14);
        // 후보자 표시
        ctx.font = 'bold 9pt NanumSquareNeo, sans-serif';
        this.topCandidates.forEach((candidate, index)=>{
            const y = startY + padding + 14 + lineHeight * (index + 1);
            const badgeX = startX + padding;
            const badgeY = y - 8;
            const badgeSize = 20;
            const badgeColor = '#00FFA3';
            ctx.fillStyle = badgeColor;
            ctx.beginPath();
            ctx.arc(badgeX + badgeSize / 2, badgeY + badgeSize / 2, badgeSize / 2, 0, Math.PI * 2);
            ctx.fill();
            ctx.fillStyle = '#000';
            ctx.font = 'bold 9 NanumSquareNeo, sans-serif';
            ctx.textAlign = 'center';
            ctx.fillText(`${index + 1}`, badgeX + badgeSize / 2, badgeY + badgeSize / 2 + 4);
            ctx.fillStyle = candidate.marble.color;
            ctx.font = 'bold 9pt NanumSquareNeo, sans-serif';
            ctx.textAlign = 'left';
            let displayText;
            if (winnerCount >= 2 && isFinalWinners) // 2명 이상 우승 모드이고 최종 우승자 확정 시: 모두 "우승!" 표시
            displayText = `${candidate.marble.name} \u{1F389}\u{C6B0}\u{C2B9}!`;
            else if (candidate.isWinner) displayText = `${candidate.marble.name} (\u{ACE8}\u{C778}!)`;
            else {
                const heightValue = Math.max(0, Math.floor(stage.goalY - candidate.marble.y));
                displayText = `${candidate.marble.name} (${heightValue}m)`;
            }
            ctx.fillText(displayText, badgeX + badgeSize + 5, y + 4);
        });
        ctx.restore();
    }
    calculateTopCandidates(marbles, winners, winnerRank, isLastWinner, displayCount) {
        const sortedMarbles = isLastWinner ? [
            ...marbles
        ].sort((a, b)=>a.y - b.y) : [
            ...marbles
        ].sort((a, b)=>b.y - a.y);
        const recentWinners = isLastWinner ? [
            ...winners
        ].reverse() : [
            ...winners
        ];
        const combinedCandidates = [];
        if (isLastWinner) {
            sortedMarbles.forEach((marble, index)=>{
                if (combinedCandidates.length < displayCount) combinedCandidates.push({
                    marble: marble,
                    rank: winners.length + index,
                    isWinner: false
                });
            });
            recentWinners.forEach((marble, index)=>{
                if (combinedCandidates.length < displayCount) combinedCandidates.push({
                    marble: marble,
                    rank: winners.length - 1 - index,
                    isWinner: true
                });
            });
        } else {
            recentWinners.slice(0, displayCount).forEach((marble, index)=>{
                combinedCandidates.push({
                    marble: marble,
                    rank: index,
                    isWinner: true
                });
            });
            sortedMarbles.forEach((marble, index)=>{
                if (combinedCandidates.length < displayCount) combinedCandidates.push({
                    marble: marble,
                    rank: winners.length + index,
                    isWinner: false
                });
            });
        }
        this.topCandidates = combinedCandidates;
    }
    update(deltaTime) {
    // 필요시 업데이트 로직 추가
    }
    getBoundingBox() {
        return null; // 이 UI는 클릭 영역이 필요없음
    }
    onMouseDown() {
        return false;
    }
    onMouseMove() {
        return false;
    }
    onMouseUp() {
        return false;
    }
    onWheel() {}
}


/**
 * @param {Parameters<import('box2d-wasm')>} args
 * @return {ReturnType<import('box2d-wasm')>}
 */ 

var $e6be656c8b5afbd4$export$2e2bcd8739ae039 = async (...args)=>{
    /**
   * This validation expression comes from wasm-feature-detect:
   * https://github.com/GoogleChromeLabs/wasm-feature-detect
   * 
   * Copyright 2019 Google Inc. All Rights Reserved.
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *     http://www.apache.org/licenses/LICENSE-2.0
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */ const hasSIMD = WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        10,
        1,
        8,
        0,
        65,
        0,
        253,
        15,
        253,
        98,
        11
    ]));
    /** @type {{ 'default': import('box2d-wasm') }} */ const Box2DModule = await (hasSIMD ? (parcelRequire("iyjrR")) : (parcelRequire("8ZFBQ")));
    const { 'default': Box2DFactory } = Box2DModule;
    // awaiting gives us a better stack trace (at the cost of an extra microtask)
    return await Box2DFactory(...args);
};


class $fafe2abfa7f98b9f$export$81ba3d9458692cc2 {
    async init() {
        this.Box2D = await (0, $e6be656c8b5afbd4$export$2e2bcd8739ae039)();
        this.gravity = new this.Box2D.b2Vec2(0, 10);
        this.world = new this.Box2D.b2World(this.gravity);
        console.log('box2d ready');
    }
    clear() {
        this.clearEntities();
    }
    clearMarbles() {
        Object.values(this.marbleMap).forEach((body)=>{
            this.world.DestroyBody(body);
        });
        this.marbleMap = {};
    }
    createStage(stage) {
        this.createEntities(stage.entities);
    }
    createEntities(entities) {
        if (!entities) return;
        const bodyTypes = {
            static: this.Box2D.b2_staticBody,
            kinematic: this.Box2D.b2_kinematicBody
        };
        entities.forEach((entity)=>{
            const bodyDef = new this.Box2D.b2BodyDef();
            bodyDef.set_type(bodyTypes[entity.type]);
            const body = this.world.CreateBody(bodyDef);
            const fixtureDef = new this.Box2D.b2FixtureDef();
            fixtureDef.set_density(entity.props.density);
            fixtureDef.set_restitution(entity.props.restitution);
            let shape;
            switch(entity.shape.type){
                case 'box':
                    shape = new this.Box2D.b2PolygonShape();
                    shape.SetAsBox(entity.shape.width, entity.shape.height, 0, entity.shape.rotation);
                    fixtureDef.set_shape(shape);
                    body.CreateFixture(fixtureDef);
                    break;
                case 'polyline':
                    shape = new this.Box2D.b2EdgeShape();
                    for(let i = 0; i < entity.shape.points.length - 1; i++){
                        const p1 = entity.shape.points[i];
                        const p2 = entity.shape.points[i + 1];
                        const v1 = new this.Box2D.b2Vec2(p1[0], p1[1]);
                        const v2 = new this.Box2D.b2Vec2(p2[0], p2[1]);
                        const edge = new this.Box2D.b2EdgeShape();
                        edge.SetTwoSided(v1, v2);
                        body.CreateFixture(edge, 1);
                    }
                    break;
                case 'circle':
                    shape = new this.Box2D.b2CircleShape();
                    shape.set_m_radius(entity.shape.radius);
                    fixtureDef.set_shape(shape);
                    body.CreateFixture(fixtureDef);
                    break;
            }
            body.SetAngularVelocity(entity.props.angularVelocity);
            body.SetTransform(new this.Box2D.b2Vec2(entity.position.x, entity.position.y), 0);
            this.entities.push({
                body: body,
                x: entity.position.x,
                y: entity.position.y,
                angle: 0,
                shape: entity.shape,
                life: entity.props.life ?? -1
            });
        });
    }
    clearEntities() {
        this.entities.forEach((entity)=>{
            this.world.DestroyBody(entity.body);
        });
        this.entities = [];
    }
    createMarble(id, x, y) {
        const circleShape = new this.Box2D.b2CircleShape();
        circleShape.set_m_radius(0.25);
        const bodyDef = new this.Box2D.b2BodyDef();
        bodyDef.set_type(this.Box2D.b2_dynamicBody);
        bodyDef.set_position(new this.Box2D.b2Vec2(x, y));
        const body = this.world.CreateBody(bodyDef);
        body.CreateFixture(circleShape, 1 + Math.random());
        body.SetAwake(false);
        body.SetEnabled(false);
        this.marbleMap[id] = body;
    }
    shakeMarble(id) {
        const body = this.marbleMap[id];
        if (body) body.ApplyLinearImpulseToCenter(new this.Box2D.b2Vec2(Math.random() * 10 - 5, Math.random() * 10 - 5), true);
    }
    removeMarble(id) {
        const marble = this.marbleMap[id];
        if (marble) {
            this.world.DestroyBody(marble);
            delete this.marbleMap[id];
        }
    }
    getMarblePosition(id) {
        const marble = this.marbleMap[id];
        if (marble) {
            const pos = marble.GetPosition();
            return {
                x: pos.x,
                y: pos.y,
                angle: marble.GetAngle()
            };
        } else return {
            x: 0,
            y: 0,
            angle: 0
        };
    }
    getEntities() {
        return this.entities.map((entity)=>{
            return {
                ...entity,
                angle: entity.body.GetAngle()
            };
        });
    }
    impact(id) {
        const src = this.marbleMap[id];
        if (!src) return;
        Object.values(this.marbleMap).forEach((body)=>{
            if (body === src) return;
            const distVector = new this.Box2D.b2Vec2(body.GetPosition().x, body.GetPosition().y);
            distVector.op_sub(src.GetPosition());
            const distSq = distVector.LengthSquared();
            if (distSq < 100) {
                distVector.Normalize();
                const power = 1 - distVector.Length() / 10;
                distVector.op_mul(power * power * 5);
                body.ApplyLinearImpulseToCenter(distVector, true);
            }
        });
    }
    start() {
        for(const key in this.marbleMap){
            const marble = this.marbleMap[key];
            marble.SetAwake(true);
            marble.SetEnabled(true);
        }
    }
    step(deltaSeconds) {
        this.deleteCandidates.forEach((body)=>{
            this.world.DestroyBody(body);
        });
        this.deleteCandidates = [];
        this.world.Step(deltaSeconds, 6, 2);
        for(let i = this.entities.length - 1; i >= 0; i--){
            const entity = this.entities[i];
            if (entity.life > 0) {
                const edge = entity.body.GetContactList();
                if (edge.contact && edge.contact.IsTouching()) {
                    this.deleteCandidates.push(entity.body);
                    this.entities.splice(i, 1);
                }
            }
        }
    }
    constructor(){
        this.marbleMap = {};
        this.entities = [];
        this.deleteCandidates = [];
    }
}



class $edfb0080e3205638$export$bdce5325d183ff94 {
    constructor(){
        this.bound = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this.isEnabled = false;
        this.icon = new Image();
        this.icon.src = new URL($fde943b0087de629$exports).toString();
    }
    get speed() {
        return this.isEnabled ? 2 : 1;
    }
    update(deltaTime) {}
    render(ctx, params, width, height) {
        this.bound.w = width / 2;
        this.bound.h = height / 2;
        this.bound.x = this.bound.w / 2;
        this.bound.y = this.bound.h / 2;
        const centerX = this.bound.x + this.bound.w / 2;
        const centerY = this.bound.y + this.bound.h / 2;
        if (this.isEnabled) {
            ctx.save();
            ctx.strokeStyle = 'white';
            ctx.globalAlpha = 0.5;
            ctx.drawImage(this.icon, centerX - 25, centerY - 25, 25, 25);
            ctx.restore();
        }
    }
    getBoundingBox() {
        return this.bound;
    }
    onMouseDown(e) {
        this.isEnabled = true;
    }
    onMouseUp(e) {
        this.isEnabled = false;
    }
}


class $7c756c59aac10daa$export$4929751e8471403 extends EventTarget {
    get isReady() {
        return this._isReady;
    }
    constructor(){
        super(), this._marbles = [], this._lastTime = 0, this._elapsed = 0, this._noMoveDuration = 0, this._shakeAvailable = false, this._updateInterval = 10, this._timeScale = 1, this._speed = 1, this._winners = [], this._particleManager = new (0, $69fffa06e2cc8da9$export$6658904c50100579)(), this._stage = null, this._camera = new (0, $238457a12dbae9c5$export$79f141de891a5fed)(), this._renderer = new (0, $68facf3481e408fc$export$a1ed140729fa937)(), this._effects = [], this._winnerRank = 0, this._totalMarbleCount = 0, this._goalDist = Infinity, this._isRunning = false, this._winner = null, this._uiObjects = [], this._isReady = false;
        this._renderer.init().then(()=>{
            this._init().then(()=>{
                this._isReady = true;
                this._update();
            });
        });
    }
    getZoom() {
        return (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c) * this._camera.zoom;
    }
    addUiObject(obj) {
        this._uiObjects.push(obj);
        if (obj.onWheel) this._renderer.canvas.addEventListener('wheel', obj.onWheel);
        if (obj.onMessage) obj.onMessage((msg)=>{
            console.log('onMessage', msg);
            this.dispatchEvent(new CustomEvent('message', {
                detail: msg
            }));
        });
    }
    _update() {
        if (!this._lastTime) this._lastTime = Date.now();
        const currentTime = Date.now();
        this._elapsed += (currentTime - this._lastTime) * this._speed * this.fastForwarder.speed;
        if (this._elapsed > 100) this._elapsed %= 100;
        this._lastTime = currentTime;
        const interval = this._updateInterval / 1000 * this._timeScale;
        while(this._elapsed >= this._updateInterval){
            this.physics.step(interval);
            this._updateMarbles(this._updateInterval);
            this._particleManager.update(this._updateInterval);
            this._updateEffects(this._updateInterval);
            this._elapsed -= this._updateInterval;
            this._uiObjects.forEach((obj)=>obj.update(this._updateInterval));
        }
        if (this._marbles.length > 1) this._marbles.sort((a, b)=>b.y - a.y);
        if (this._stage) {
            this._camera.update({
                marbles: this._marbles,
                stage: this._stage,
                needToZoom: this._goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 4,
                targetIndex: this._winners.length > 0 ? this._winnerRank - this._winners.length : 0,
                winnerRank: this._winnerRank,
                winnersCount: this._winners.length,
                totalMarbleCount: this._totalMarbleCount
            });
            if (this._isRunning && this._marbles.length > 0 && this._noMoveDuration > 3000) this._changeShakeAvailable(true);
            else this._changeShakeAvailable(false);
        }
        this._render();
        window.requestAnimationFrame(this._update);
    }
    _updateMarbles(deltaTime) {
        if (!this._stage) return;
        const winnerCount = (0, $2573268c577c952d$export$2e2bcd8739ae039).winnerCount;
        const isLastWinner = this._winnerRank >= this._totalMarbleCount - 1;
        for(let i = 0; i < this._marbles.length; i++){
            const marble = this._marbles[i];
            marble.update(deltaTime);
            if (marble.skill === (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).Impact) {
                this._effects.push(new (0, $43c01f2b0f9df660$export$2faf2590ac4901e1)(marble.x, marble.y));
                this.physics.impact(marble.id);
            }
            if (marble.y > this._stage.goalY) {
                this._winners.push(marble);
                // 우승자 수에 따른 게임 종료 로직 분기
                if (winnerCount === 1) {
                    // 1명 우승자: 기존 로직 (폭죽 + 우승자 표시 + topCandidates 숨김)
                    if (this._isRunning && this._winners.length === this._winnerRank + 1) {
                        this.dispatchEvent(new CustomEvent('goal', {
                            detail: {
                                winner: marble.name
                            }
                        }));
                        this._winner = marble;
                        this._isRunning = false;
                        this._particleManager.shot(this._renderer.width, this._renderer.height);
                        this.topCandidatesRenderer.setGameStarted(false);
                    } else if (this._isRunning && this._winnerRank === this._winners.length && this._winnerRank === this._totalMarbleCount - 1) {
                        this.dispatchEvent(new CustomEvent('goal', {
                            detail: {
                                winner: this._marbles[i + 1].name
                            }
                        }));
                        this._winner = this._marbles[i + 1];
                        this._isRunning = false;
                        this._particleManager.shot(this._renderer.width, this._renderer.height);
                        this.topCandidatesRenderer.setGameStarted(false);
                    }
                } else {
                    // 2명 이상 우승자: topCandidates 유지
                    if (isLastWinner) {
                        // 마지막 당첨 모드: 골인 후 남은 구슬이 winnerCount 명일 때 게임 종료
                        // for 루프 내에서 아직 marbles가 필터링되지 않았으므로 marbles.length - 1이 실제 남은 수
                        const remainingAfterGoal = this._marbles.length - 1;
                        if (this._isRunning && remainingAfterGoal === winnerCount) {
                            this.dispatchEvent(new CustomEvent('goal', {
                                detail: {
                                    winner: `\u{CD5C}\u{C885} ${winnerCount}\u{C778} \u{D655}\u{C815}!`
                                }
                            }));
                            this._isRunning = false;
                            this._particleManager.shot(this._renderer.width, this._renderer.height);
                        // topCandidates는 유지
                        }
                    } else // 첫번째 당첨 모드: 골인한 구슬이 winnerCount 명일 때 게임 종료
                    if (this._isRunning && this._winners.length === winnerCount) {
                        this.dispatchEvent(new CustomEvent('goal', {
                            detail: {
                                winner: `\u{CD5C}\u{C885} ${winnerCount}\u{C778} \u{D655}\u{C815}!`
                            }
                        }));
                        this._isRunning = false;
                        this._particleManager.shot(this._renderer.width, this._renderer.height);
                    // topCandidates는 유지
                    }
                }
                setTimeout(()=>{
                    this.physics.removeMarble(marble.id);
                }, 500);
            }
        }
        const targetIndex = this._winnerRank - this._winners.length;
        const topY = this._marbles[targetIndex] ? this._marbles[targetIndex].y : 0;
        this._goalDist = Math.abs(this._stage.zoomY - topY);
        this._timeScale = this._calcTimeScale();
        this._marbles = this._marbles.filter((marble)=>marble.y <= this._stage.goalY);
    }
    _calcTimeScale() {
        if (!this._stage) return 1;
        const targetIndex = this._winnerRank - this._winners.length;
        // 마지막 당첨 모드인지 확인
        const isLastWinner = this._winnerRank >= this._totalMarbleCount - 1;
        const hasWinners = this._winners.length > 0;
        // 마지막 당첨 모드이고, 첫 번째 구슬이 통과했으며, 구슬이 10개 이하일 때 슬로우모션
        if (isLastWinner && hasWinners && this._marbles.length <= 10) return 0.3; // 슬로우모션 (최종 5인 결정 전까지)
        // 첫번째 당첨 모드이고, 결승지점 근처일 때 슬로우모션
        if (!isLastWinner && this._goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 3) return 0.3; // 슬로우모션
        if (this._winners.length < this._winnerRank + 1 && this._goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) {
            if (this._marbles[targetIndex].y > this._stage.zoomY - (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 1.0 && (this._marbles[targetIndex - 1] || this._marbles[targetIndex + 1])) return Math.max(0.2, this._goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf));
        }
        return 1;
    }
    _updateEffects(deltaTime) {
        this._effects.forEach((effect)=>effect.update(deltaTime));
        this._effects = this._effects.filter((effect)=>!effect.isDestroy);
    }
    _render() {
        if (!this._stage) return;
        const renderParams = {
            camera: this._camera,
            stage: this._stage,
            entities: this.physics.getEntities(),
            marbles: this._marbles,
            winners: this._winners,
            particleManager: this._particleManager,
            effects: this._effects,
            winnerRank: this._winnerRank,
            winner: this._winner,
            size: {
                x: this._renderer.width,
                y: this._renderer.height
            },
            totalMarbleCount: this._totalMarbleCount,
            winnerCount: (0, $2573268c577c952d$export$2e2bcd8739ae039).winnerCount
        };
        this._renderer.render(renderParams, this._uiObjects);
    }
    async _init() {
        this.physics = new (0, $fafe2abfa7f98b9f$export$81ba3d9458692cc2)();
        await this.physics.init();
        this.addUiObject(new (0, $e0350dec16bbe919$export$795f70ffe4ca76fc)());
        this.attachEvent();
        const minimap = new (0, $c2ea39beabe51779$export$a8b4308ba35ee473)();
        minimap.onViewportChange((pos)=>{
            if (pos) {
                this._camera.setPosition(pos, false);
                this._camera.lock(true);
            } else this._camera.lock(false);
        });
        this.addUiObject(minimap);
        this.fastForwarder = new (0, $edfb0080e3205638$export$bdce5325d183ff94)();
        this.addUiObject(this.fastForwarder);
        this.topCandidatesRenderer = new (0, $4dadba5eb7b1114b$export$ce9eedc15a17214)();
        this.addUiObject(this.topCandidatesRenderer);
        this._stage = (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05)[0];
        this._loadMap();
    }
    mouseHandler(eventName, e) {
        const handlerName = `on${eventName}`;
        const sizeFactor = this._renderer.sizeFactor;
        const pos = {
            x: e.offsetX * sizeFactor,
            y: e.offsetY * sizeFactor
        };
        this._uiObjects.forEach((obj)=>{
            if (!obj[handlerName]) return;
            const bounds = obj.getBoundingBox();
            if (!bounds) obj[handlerName]({
                ...pos,
                button: e.button
            });
            else if (bounds && pos.x >= bounds.x && pos.y >= bounds.y && pos.x <= bounds.x + bounds.w && pos.y <= bounds.y + bounds.h) obj[handlerName]({
                x: pos.x - bounds.x,
                y: pos.y - bounds.y,
                button: e.button
            });
            else obj[handlerName](undefined);
        });
    }
    attachEvent() {
        [
            'MouseMove',
            'MouseUp',
            'MouseDown',
            'DblClick'
        ].forEach((ev)=>{
            // @ts-ignore
            this._renderer.canvas.addEventListener(ev.toLowerCase().replace('mouse', 'pointer'), this.mouseHandler.bind(this, ev));
        });
        this._renderer.canvas.addEventListener('contextmenu', (e)=>{
            e.preventDefault();
        });
    }
    _loadMap() {
        if (!this._stage) throw new Error('No map has been selected');
        this.physics.createStage(this._stage);
        this._camera.initializePosition();
    }
    clearMarbles() {
        this.physics.clearMarbles();
        this._winner = null;
        this._winners = [];
        this._marbles = [];
    }
    start() {
        this._isRunning = true;
        this._winnerRank = (0, $2573268c577c952d$export$2e2bcd8739ae039).winningRank;
        if (this._winnerRank >= this._marbles.length) this._winnerRank = this._marbles.length - 1;
        this._camera.startFollowingMarbles();
        this.physics.start();
        this._marbles.forEach((marble)=>marble.isActive = true);
        // 게임 시작 시 상위 후보 표시 활성화
        this.topCandidatesRenderer.setGameStarted(true);
    }
    setSpeed(value) {
        if (value <= 0) throw new Error('Speed multiplier must larger than 0');
        this._speed = value;
    }
    getSpeed() {
        return this._speed;
    }
    setWinningRank(rank) {
        this._winnerRank = rank;
    }
    setTitle(title) {
        this._renderer.setTitle(title);
    }
    setMarbles(names) {
        this.reset();
        const arr = names.slice();
        let maxWeight = -Infinity;
        let minWeight = Infinity;
        const members = arr.map((nameString)=>{
            const result = (0, $28770b279d7ab5b1$export$5d945868514965a9)(nameString);
            if (!result) return null;
            const { name: name, weight: weight, count: count } = result;
            if (weight > maxWeight) maxWeight = weight;
            if (weight < minWeight) minWeight = weight;
            return {
                name: name,
                weight: weight,
                count: count
            };
        }).filter((member)=>!!member);
        const gap = maxWeight - minWeight;
        let totalCount = 0;
        members.forEach((member)=>{
            if (member) {
                member.weight = 0.1 + (gap ? (member.weight - minWeight) / gap : 0);
                totalCount += member.count;
            }
        });
        const orders = Array(totalCount).fill(0).map((_, i)=>i).sort(()=>Math.random() - 0.5);
        members.forEach((member)=>{
            if (member) for(let j = 0; j < member.count; j++){
                const order = orders.pop() || 0;
                this._marbles.push(new (0, $e7b6517817360fee$export$e91dba6fa3f67f68)(this.physics, order, totalCount, member.name, member.weight));
            }
        });
        this._totalMarbleCount = totalCount;
    }
    _clearMap() {
        this.physics.clear();
        this._marbles = [];
    }
    reset() {
        this.clearMarbles();
        this._clearMap();
        this._loadMap();
        this._goalDist = Infinity;
    }
    getCount() {
        return this._marbles.length;
    }
    _changeShakeAvailable(v) {
        if (this._shakeAvailable !== v) {
            this._shakeAvailable = v;
            this.dispatchEvent(new CustomEvent('shakeAvailableChanged', {
                detail: v
            }));
        }
    }
    shake() {
        if (!this._shakeAvailable) return;
    }
    getMaps() {
        return (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).map((stage, index)=>{
            return {
                index: index,
                title: stage.title
            };
        });
    }
    setMap(index) {
        if (index < 0 || index > (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).length - 1) throw new Error('Incorrect map number');
        const names = this._marbles.map((marble)=>marble.name);
        this._stage = (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05)[index];
        this.setMarbles(names);
        this._camera.initializePosition();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $7c756c59aac10daa$export$4929751e8471403.prototype, "_update", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $7c756c59aac10daa$export$4929751e8471403.prototype, "mouseHandler", null);



function $786dbfa54806ab0b$export$c6245babf0c60892() {
    if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
        const swUrl = `${window.location.origin}/roulette/service-worker.js`;
        navigator.serviceWorker.register(swUrl).then((reg)=>console.log('service worker registered', reg.scope)).catch((err)=>console.error('service worker registration failed', err));
    });
}


(0, $786dbfa54806ab0b$export$c6245babf0c60892)();
const $b4e14b6b8da86996$var$roulette = new (0, $7c756c59aac10daa$export$4929751e8471403)();
// eslint-disable-next-line
window.roulette = $b4e14b6b8da86996$var$roulette;
// eslint-disable-next-line
window.options = (0, $2573268c577c952d$export$2e2bcd8739ae039);


//# sourceMappingURL=roullet_chzzk.4bb85d48.js.map
